import script from "./communityWillAuditApplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityWillAuditApplyList.vue?vue&type=script&lang=ts&setup=true"

import "./communityWillAuditApplyList.vue?vue&type=style&index=0&id=932a205a&lang=less"

const __exports__ = script;

export default __exports__